import styled from 'styled-components';
import { Layout } from 'antd';
import { useHistory } from 'react-router-dom';
import DesktopHeader from './DesktopHeader';
import MobilHeader from './MobilHeader';
import { CustomImage } from '../index';
import edenredDesktopIcon from '@src/assets/icons/edenred-desktop-icon.svg';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAdminUserMenus, getUserMenus } from '@src/store/slice/menusSlice';
import { getCustomerVouList } from '@src/store/slice/customerSlice';
import { useLang } from '@src/context';

const { Header } = Layout;

const CustomHeader = styled(Header)`
  display: flex;
  position: fixed;
  z-index: 11;
  width: 100%;

  @media (max-width: 767.98px) {
    height: 80px;
    line-height: 80px;
  }

  @media (min-width: 768px) and (max-width: 991.98px) {
    height: 80px;
    line-height: 80px;
  }

  @media (min-width: 992px) {
    height: 100px;
    line-height: 100px;
  }
`;

const HeaderLeft = styled.div`
  width: 256px;
  height: 100px;
  line-height: 0;
  margin: 0 0 8px;
  padding: 20px 36px 26px 35px;
  background-image: linear-gradient(to bottom, #fff, #fff);
`;

const HeaderRight = styled.div`
  box-shadow: inset 0 -1px 0 0 #e4e4e4, inset 48px -6px 9px -46px #ededed;
  line-height: 0;
  background-color: #fff;

  @media (max-width: 767.98px) {
    height: 80px;
    width: 100%;
    padding: 0 24px;
  }

  @media (min-width: 768px) and (max-width: 991.98px) {
    height: 80px;
    width: 100%;
    padding: 0 36px;
  }

  @media (min-width: 992px) {
    height: 100px;
    width: calc(100% - 256px);
    padding: 0 48px;
  }
`;

const Headers = ({ collapsed, setCollapsed, isDesktop }) => {
  const history = useHistory();

  const dispatch = useDispatch();
  const { selectedCustomer } = useSelector((state) => state?.customer);
  const { menus } = useSelector((state) => state?.menus);
  const { isAdmin } = useSelector((state) => state?.auth);
  const { language } = useLang();

  useEffect(() => {
    if (selectedCustomer?.customerId) {
      dispatch(
        getCustomerVouList({
          customerId: selectedCustomer?.customerId,
          vouId: 1,
        }),
      );
      if (!isAdmin) {
        dispatch(
          getUserMenus({
            customerId: selectedCustomer?.customerId,
          }),
        );
      } else {
        dispatch(getAdminUserMenus());
      }
    }
  }, [selectedCustomer?.customerId, isAdmin, language, dispatch]);

  const gotoHomePage = () => {
    if (isAdmin) {
      history.push('/admin/dashboard');
    } else {
      history.push('/dashboard');
    }
  };

  return (
    <CustomHeader>
      {isDesktop === true && (
        <HeaderLeft>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <CustomImage
              src={edenredDesktopIcon}
              style={{ cursor: 'pointer', marginTop: '-4px', width: '100px' }}
              onClick={gotoHomePage}
            />
            {/*<CustomImage*/}
            {/*//src={collapsed ? menuOpen : menuOpen}*/}
            {/*src={menuOpen}*/}
            {/*onClick={() => setCollapsed(!collapsed)}*/}
            {/*style={{ cursor: 'pointer' }}*/}
            {/*/>*/}
          </div>
        </HeaderLeft>
      )}
      <HeaderRight>
        {isDesktop === true ? (
          <DesktopHeader />
        ) : (
          <MobilHeader collapsed={collapsed} setCollapsed={setCollapsed} />
        )}
      </HeaderRight>
    </CustomHeader>
  );
};

export default Headers;
